import { SubmissionError } from 'redux-form';
import { fetch } from '../../utils/dataAccess';
import { success as successList } from './list';
import { success as retrieveSuccess } from './show';
import {success as deleteSuccess} from "./delete";

export function error(error) {
  return { type: 'ONEWAYINTERVIEW_REVIEW_SAVE_ERROR', error };
}

export function loading(loading) {
  return { type: 'ONEWAYINTERVIEW_REVIEW_SAVE_LOADING', loading };
}

export function success(saved) {
  return { type: 'ONEWAYINTERVIEW_REVIEW_SAVE_SUCCESS', saved: saved };
}

export function save(values, url = 'one_way_interview_reviews',  method = 'POST') {
  return dispatch => {
    dispatch(loading(true));
    return fetch(url, { method: method, data: values })
      .then(response => {
        dispatch(successList(null));
        dispatch(loading(false));
        dispatch(success(response.data));
      })
      .catch(e => {
        dispatch(loading(false));

        if (e instanceof SubmissionError) {
          dispatch(error(e.errors._error));
          throw e;
        }

        dispatch(error(e.message));
      });
  };
}

export function reset() {
  return dispatch => {
    dispatch(loading(false));
    dispatch(error(null));
    dispatch(success(null));
    dispatch(retrieveSuccess(null));
    dispatch(deleteSuccess(null));
  };
}
